// Localização: frontend/src/components/Financeiro/FormCategoria.jsx

import React, { useState } from 'react';
import PrimaryButton from '../Common/PrimaryButton';

const FormCategoria = ({ initialData, onSubmit, onClose, isEditing }) => {
    const [formData, setFormData] = useState({
        nome: '',
        tipo: 'Receita',
        descricao: '',
        cor: '#3B82F6',
        icone: '',
        ativo: true,
        ...initialData
    });
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);

        // Validações
        if (!formData.nome || !formData.tipo) {
            setError('Nome e tipo são obrigatórios.');
            return;
        }

        if (!['Receita', 'Despesa'].includes(formData.tipo)) {
            setError('Tipo inválido. Deve ser "Receita" ou "Despesa".');
            return;
        }

        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                    {error}
                </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Nome da Categoria <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                        required
                        placeholder="Ex: Consultas"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Tipo <span className="text-red-500">*</span>
                    </label>
                    <select
                        name="tipo"
                        value={formData.tipo}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                        required
                    >
                        <option value="Receita">Receita</option>
                        <option value="Despesa">Despesa</option>
                    </select>
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Descrição
                </label>
                <textarea
                    name="descricao"
                    value={formData.descricao || ''}
                    onChange={handleChange}
                    rows="3"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                    placeholder="Descrição da categoria..."
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Cor
                    </label>
                    <div className="flex items-center gap-3">
                        <input
                            type="color"
                            name="cor"
                            value={formData.cor}
                            onChange={handleChange}
                            className="h-12 w-20 rounded border border-gray-300 cursor-pointer"
                            title="Selecione uma cor"
                        />
                        <div className="flex-1">
                            <div 
                                className="h-10 w-full rounded-md border border-gray-300 flex items-center justify-center text-sm text-gray-600 font-mono"
                                style={{ backgroundColor: formData.cor }}
                            >
                                <span className={formData.cor && formData.cor.toLowerCase() !== '#ffffff' ? 'text-white' : 'text-gray-800'}>
                                    {formData.cor}
                                </span>
                            </div>
                            <p className="mt-1 text-xs text-gray-500">
                                Clique no seletor para escolher a cor
                            </p>
                        </div>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Ícone (Lucide React)
                    </label>
                    <input
                        type="text"
                        name="icone"
                        value={formData.icone || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                        placeholder="Ex: Stethoscope"
                    />
                    <p className="mt-1 text-xs text-gray-500">
                        Nome do ícone do lucide-react (opcional)
                    </p>
                </div>
            </div>

            {isEditing && (
                <div className="flex items-center">
                    <input
                        type="checkbox"
                        name="ativo"
                        checked={formData.ativo}
                        onChange={handleChange}
                        className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300 rounded"
                    />
                    <label className="ml-2 block text-sm text-gray-700">
                        Categoria ativa
                    </label>
                </div>
            )}

            <div className="flex justify-end space-x-2 mt-6 pt-4 border-t border-gray-200">
                <PrimaryButton
                    type="button"
                    onClick={onClose}
                    className="bg-gray-500 hover:bg-gray-700"
                >
                    Cancelar
                </PrimaryButton>
                <PrimaryButton type="submit">
                    {isEditing ? 'Salvar Alterações' : 'Cadastrar'}
                </PrimaryButton>
            </div>
        </form>
    );
};

export default FormCategoria;

